module.exports = __webpack_public_path__ + "static/media/helengeli-40.0cb81202.jpg";